export const actionTypes = {
    FetchMultipleAsinsAnalysis: "[FetchMultipleAsinsAnalysis] Action",
    UpdateMultipleAsinsAnalysis: "[UpdateMultipleAsinsAnalysis] Action",
    FetchSuggestedKeywords: "[FetchSuggestedKeywords] Action",
    UpdateSuggestedKeywords: "[UpdateSuggestedKeywords] Action",
    ClearResultsAnalysis: "[ClearResultsAnalysis] Action",
};